import { Articulo } from '@/__env/lib/Articulos';
import { ControladorInterfaz } from '@/views/a-pedido-cargar/controlador';
import { ControladorNuevoItem } from '@/views/a-pedido-cargar/controlador-item';
import { Cliente } from '@/__env/lib/Clientes';
import { Vendedor } from '@/__env/lib/Ventas/Vendedores';
import { SignalDispatcher } from 'strongly-typed-events';
import moment, { Moment } from 'moment';
import { Envio } from '@/__env/lib/Ventas/Envios';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Item as ItemPedido } from '@/__env/lib/Ventas/Pedidos/Item';
import { Utiles } from '@/__env/pluggins/event-bus';
import _ from 'lodash';
import { OpcionDePrecio } from '@/__env/lib/Articulos/Articulo.lib';
import { Wait } from '@/__env/ext';
import { Pago } from '@/__env/lib/Ventas/Pagos';
import { isNumber } from 'util';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import * as Pagos from '@/__env/lib/Ventas/Pagos';

export class ControladorNuevoPedido
{

    constructor( controlador: ControladorInterfaz )
    {
        this.Controlador = controlador;
        this.NuevoItem = new ControladorNuevoItem( this );
        this.Iniciar();

    }

    protected Controlador: ControladorInterfaz;
    public NuevoItem: ControladorNuevoItem;

    public Items: Item[] = [];

    protected tipo: Pedidos.Tipos = Pedidos.Tipos.NoEspecificado;
    public get Tipo()
    {
        return this.tipo;

    } public set Tipo( x: Pedidos.Tipos )
    {
        this.tipo = x;
        this._onTipo.dispatch();
        this.ActualizarTotales();
    }

    public ComisionPorVenta: number = 0;
    public get CostoDeEnvio()
    {
        return this.envio.Importes.Propio;

    }
    public set CostoDeEnvio( x: number )
    {
        this.envio.Importes.Propio = Math.abs( Number( x ) );
        this.ActualizarTotales();
    }


    protected envio: Envio = new Envio();
    public get Envio()
    {
        return this.envio;

    } public set Envio( x: Envio )
    {
        this.envio = x;
        this._onEnvio.dispatch();
        this.ActualizarTotales();
    }

    public Pagos: Pago[] = [];
    protected cliente: Cliente = new Cliente();
    public get Cliente()
    {
        return this.cliente;

    } public set Cliente( x: Cliente )
    {
        this.cliente = x;
        this._onCliente.dispatch();
        this.ActualizarTotales();
    }

    protected vendedor: Vendedor = new Vendedor();
    public get Vendedor()
    {
        return this.vendedor;

    } public set Vendedor( x: Vendedor )
    {
        this.vendedor = x;
        this._onVendedor.dispatch();
        this.ActualizarTotales();
    }

    private _onTipo = new SignalDispatcher();
    public get onTipo() { return this._onTipo.asEvent(); }

    private _onCliente = new SignalDispatcher();
    public get onCliente() { return this._onCliente.asEvent(); }

    private _onEnvio = new SignalDispatcher();
    public get onEnvio() { return this._onEnvio.asEvent(); }

    private _onVendedor = new SignalDispatcher();
    public get onVendedor() { return this._onVendedor.asEvent(); }

    private _onActualizarTotales = new SignalDispatcher();
    public get onActualizarTotales() { return this._onActualizarTotales.asEvent(); }

    public GuardarYContinuar: boolean = false;
    public Modo: 'plataformas' | 'normal' | 'mostrador' = 'normal';
    public get Iniciado()
    {
        if ( this.Modo != 'plataformas' )
        {
            return this.cliente && this.cliente.Existe &&
                this.vendedor && this.vendedor.Existe &&
                this.Tipo.Id != Pedidos.Tipos.NoEspecificado.Id &&
                ( ( this.Controlador.Pedido && this.Controlador.Pedido.Existe && this.Controlador.Pedido.Tags.Pendiente ) || (!this.Controlador.Pedido || !this.Controlador.Pedido.Existe) );
        } else
        {
            return this.IniciadoPlataforma;
        }
    }

    public get IniciadoPlataforma()
    {
        return this.vendedor && this.vendedor.Existe &&
            !this.Tipo.esNoEspecificado &&
            ( ( this.Controlador.Pedido && this.Controlador.Pedido.Existe && this.Controlador.Pedido.Tags.Pendiente ) || ( !this.Controlador.Pedido || !this.Controlador.Pedido.Existe ) );
    }

    public Iniciar()
    {
        this.NuevoItem.onActualizar.subscribe( () =>
        {
            this.ActualizarTotales();
        } );
    }

    public Totales: Totales = new Totales();
    async ActualizarTotales()
    {
        await Wait( 300 );
        this.Totales.Items = this.Items.length;
        this.Totales.Neto = this.Items.reduce( ( a, x ) => a + x.Articulo.Precio.Importes.Neto, 0 );
        this.Totales.Envio = isNumber( this.CostoDeEnvio ) ? this.CostoDeEnvio : 0;
        this.Totales.Impuestos = this.Items.reduce( ( a, x ) => a + x.Articulo.Precio.Importes.Iva, 0 );
        this.Totales.Final = this.Totales.Envio + this.Items.reduce( ( a, x ) => a + x.Articulo.Precio.Importes.Final, 0 );
        await Wait( 100 );
        this._onActualizarTotales.dispatch();

    }

    public async Reiniciar()
    {
        this.Items.clear();
        this.cliente = new Cliente();
        this.vendedor = new Vendedor();
        this.envio = new Envio();
        this.Pagos.clear();
        //this.cliente = await Cliente.create( 504085 );
        //this.vendedor = await Vendedor.create(205);
        this.ActualizarTotales();

        if ( this.Modo == "mostrador" )
            this.Tipo = Pedidos.Tipos.Mostrador;
        else if ( this.Modo == "normal" )
            this.Tipo = Pedidos.Tipos.Normal;
        else
            this.Tipo = Pedidos.Tipos.NoEspecificado;

        if ( this.Modo == "mostrador" )
            this.envio.Tipo = Pedidos.Tipos.Mostrador.TipoEnvioPredeterminado;
        else if ( this.Modo == "normal" )
            this.envio.Tipo = Pedidos.Tipos.Normal.TipoEnvioPredeterminado;
    }

    public async AbrirPedido( x: Pedido, GuardarYContinuar: boolean = false )
    {
        this.GuardarYContinuar = GuardarYContinuar;
        if ( this.Modo == 'plataformas' )
        {
            if ( x.Existe )
            {
                await x.CargarPagos();
            }

            this.Pagos = x.Pagos;
            this.tipo = x.Tipo;
            this.vendedor = await Vendedor.create( x.Tipo.VendedorPredeterminado );
            if ( x.Tipo.ClientePredeterminado )
            {
                this.cliente = await Cliente.create( x.Tipo.ClientePredeterminado );
            } else
            {
                this.cliente = x.Cliente;
            }

        } else
        {
            this.vendedor = x.Vendedor;
            this.cliente = x.Cliente;
        }

        this.tipo = x.Tipo;
        this.envio = x.Envio;

        for ( let item of x.Items )
        {
            if ( item.PrecioFijado && item.PrecioFijado.Fijado )
            {
                let e = await this.NuevoItem.Agregar( null, null, null, item );
                if ( e.Mensaje ) Utiles.Notificaciones.Alerta( e.Mensaje );
            } else
            {
                let e = await this.NuevoItem.Agregar( item.Articulo, item.Cantidad );
                if ( e.Mensaje ) Utiles.Notificaciones.Alerta( e.Mensaje );

            }

        }

    }

    public async RecargarPrecios( x: Cliente )
    {
        if ( this.tipo.esMercadoLibre )
        {
            Utiles.Notificaciones.Alerta( 'Imposible. Pedido de MercadoLibre' );
            return;
        }

        this.cliente = x;
        for ( let item of this.Items )
        {
            item.Articulo.Precio = null;
            await this.NuevoItem.Agregar( item.Articulo, item.Cantidad );
        }
        await Wait( 100 );
        this.ActualizarTotales();

    }

    public async ComprobarErrores()
    {
        let pedido = new Pedido();

        if ( this.Modo == 'plataformas' )
        {
            if ( this.Pagos.hasRows() )
            {
                for ( let pago of this.Pagos )
                {
                    pago.Plataforma = Pagos.Plataformas.toTipo( this.Tipo.Id );
                    pago.Cuenta = this.Tipo.Id;
                    pago.Modo = 'plataforma';
                    pago.Estado = Pagos.Estados.Autorizado;
                    pago.Cliente.Nombre = this.Cliente.Vista.Descripcion;
                    pago.Cliente.Documento = this.Cliente.Cuit ? this.Cliente.Cuit : this.Cliente.Documento;
                    pago.Cliente.Telefono = this.Cliente.Contacto.Telefono;
                    pago.Cliente.Email = this.Cliente.Contacto.Email;
                    pago.Cliente.Id = this.Cliente.Id;
                    pago.Fechas.Creacion = moment();
                    pago.Importes.Total = this.Totales.Final;
                    pago.Importes.Pagado = this.Totales.Final + this.Envio.Importes.Cliente;
                    pago.CargoPorEnvio = this.Envio.Importes.Cliente;
                    pago.Comision.Porcentaje = ( pago.Comision.Monto / pago.Importes.Total );
                    pedido.Pagos.push( pago );
                    break;
                }

            }
        }

        pedido.Cliente = this.Cliente;
        pedido.Vendedor = this.Vendedor;
        pedido.Envio = this.Envio;
        pedido.Tipo = this.Tipo;
        pedido.IdExterna = this.Controlador.Pedido.IdExterna;
        if ( this.Modo == 'plataformas' )
        {
            pedido.Cuenta = this.Tipo.Id.toUpperCase();
        }

        pedido.Items.clear();
        for ( let item of this.Items )
        {
            let peditem = new ItemPedido();
            peditem.Codigo = item.Articulo.Id;
            peditem.Articulo = item.Articulo;
            peditem.IdExterna = item.Articulo.Precio.IdPublicacion;
            peditem.Cliente = this.Cliente.Id;
            peditem.Tipo = this.Tipo;
            peditem.Cantidad = item.Cantidad;
            peditem.PrecioFijado = item.Articulo.Precio;
            pedido.Items.push( peditem );
        }

        let errores = pedido.ComprobarFacturacion( true );



        return errores;
    }

}

export class Totales
{
    public Items: number = 0;
    public Neto: number = 0;
    public Final: number = 0;
    public Impuestos: number = 0;
    public Envio: number = 0;
}

export class Item
{
    constructor()
    {

    }
    public NoModificable: boolean = false;
    public Articulo: Articulo;
    public Cantidad: number = 0;
    public Ultimo: number = 0;

    public Importes = {
        Neto: 0,
        Final: 0,
        Iva: 0,
    };



}